var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mouse-leave-display",attrs:{"data-timeout":_vm.timeout}},[(_vm.isVisible)?_vm._t("default",null,{"visible":_vm.isVisible}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }